import { createRouter, createWebHistory } from 'vue-router';  // Correct import
import MainFlow from '../aggrigates/events/mainFlow.vue'; // Main Flow Component
import EventDetails from "../aggrigates/events/eventDetails.vue"
// import { useGtag } from "vue-gtag-next";

// const gtag = useGtag();

const routes = [
  {
    path: '/',
    name: 'MainFlow',
    component: MainFlow,
  },
  {
    path: '/eventdetails/:id',
    name: 'EventDetails',
    component: EventDetails,
    props: true, // Pass route params as props to the component
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Restore scroll position when navigating back
    } else {
      const savedScroll = sessionStorage.getItem('scrollPosition');
      return savedScroll ? { top: parseInt(savedScroll, 10) } : { top: 0 };
    }
  }
});

router.afterEach((to, from) => {
  if (from.name === "EventDetails" && to.name === "MainFlow") {
    // Trigger the scroll reset when navigating back
    sessionStorage.setItem('isNavigatingBack', 'true');
  }
});

// Save scroll position before leaving a page
// router.beforeEach((to, from, next) => {
//   sessionStorage.setItem('scrollPosition', window.scrollY);
//   next();
// });

// router.afterEach((to) => {
//   gtag.pageview(to.fullPath);
// });

export default router;

